import { useCallback } from "react";
import { CellValueChangedEvent } from "ag-grid-community";
import { showWarning } from "src/utils/toast/toastUtil";
import { HRM3130_R01TaxTableDto } from "../Dto_HRM3130_R01";
/** 셀 변경 훅에 전달할 상태 변경 함수이다. */
interface Props {
    updateHRM3130_R01List: (id: number, row: HRM3130_R01TaxTableDto) => void; // 편집 행 갱신
}
/** 일반 셀 변경을 검증하고 목록에 반영하는 핸들러를 반환한다. */
export const useHRM3130_R01CellChange = ({ updateHRM3130_R01List }: Props) => {
    // 갱신 함수가 바뀔 때만 셀 편집 핸들러를 다시 만든다.
    const handleCellChange = useCallback((event: CellValueChangedEvent<HRM3130_R01TaxTableDto>) => {
        const { data, colDef, newValue } = event; // 변경 행·컬럼·값
        if (event.node.rowPinned || !data || !colDef.field) return;
        const value = typeof newValue === 'number' && newValue < 0 ? 0 : newValue; // 음수 금액은 0으로 보정
        if (value !== newValue) showWarning('금액은 0보다 작을 수 없습니다.');
        updateHRM3130_R01List(data.valueIndex, { ...data, [colDef.field]: value, isModified: !data.inserted });
    }, [updateHRM3130_R01List]);
    return { handleCellChange };
};
